import React, { createContext, PropsWithChildren } from "react";

import { OnlineTemplate } from "~/entities/templateEntities";

import { defaultTemplate } from "~/theme/burgerfuel";

const ThemeContext = createContext<{
  template: OnlineTemplate;
}>({
  template: defaultTemplate,
});

type ThemeContextProviderProps = {
  template: OnlineTemplate;
};

export const ThemeContextProvider: React.FC<
  PropsWithChildren<ThemeContextProviderProps>
> = ({ template, children }) => {
  return (
    <ThemeContext.Provider value={{ template }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
